export const compositionEditorLimits = {
  minLayerSize: 8,
  minCanvasSize: 64,
  maxCanvasSize: 4096,
  // BE rejects scenes above these with 400; the editor blocks reaching them.
  maxLayers: 50,
  maxTextLength: 1000,
  defaultCanvasWidth: 1200,
  defaultCanvasHeight: 800,
  defaultLineHeight: 1.2,
  historyLimit: 100,
  centerSnapThreshold: 4,
  builtInFontFamily: 'Inter',
} as const;
